export default "__VITE_ASSET__B$trVISn__"